export default __webpack_public_path__ + "static/media/500.0300bf53.svg";